import React, { Component } from 'react';

export class AppFooter extends Component {

    render() {
        return  <div className="layout-footer">
                    <div className="p-grid">
                       
                        <div className="p-col p-col-align-right">
                            <span className="pi-md-copyright"></span>
                            <span></span>
                        </div>
                    </div>
                </div>
    }
}